import { createAsyncThunk } from '@reduxjs/toolkit'
import { applicationManagementAPI } from 'src/api/application-management'
import { IApplicationQuery } from 'src/interfaces/application-management'

// explore opportunity
export const getApplicationAction = createAsyncThunk(
  'application-management/cv/get',
  async (query: IApplicationQuery) => {
    try {
      const res = await applicationManagementAPI.getApplicationList(query)
      return res
    } catch (error) {
      throw error
    }
  }
)

export const deleteApplicationAction = createAsyncThunk(
  'application-management/cv/delete',
  async (id: string) => {
    try {
      const res = await applicationManagementAPI.deleteApplicationPost(id)
      return res
    } catch (error) {
      throw error
    }
  }
)
